var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iDetailView',{attrs:{"item":_vm.item,"attributes":[{field: 'name'},{field: 'subject'}]}}),_c('div',[_vm._v("The map")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }